import { render } from "./EliminationSettingList.vue?vue&type=template&id=5b4b6bb6&ts=true"
import script from "./EliminationSettingList.vue?vue&type=script&lang=ts"
export * from "./EliminationSettingList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__